import { orderBy } from "lodash";

/** Offtakes in the order Zenith lists them: active first, then by name. Returns a new array. */
export const orderOfftakes = <T extends { isActive?: boolean; name: string }>(
  offtakes: T[],
): T[] => orderBy(offtakes, ["isActive", "name"], ["desc", "asc"]);
